<template>
  <PageLayout title="Pair Connector Node">
    <ContentCard>
      <p class="text-muted">Generate kode di sini, lalu masukkan di ControlLabs Connector app di PC produksi.</p>
      <div class="mb-3">
        <a :href="macZip" download class="btn btn-outline-secondary btn-sm mr-2">
          <i class="fas fa-download mr-1"></i> macOS
        </a>
        <a :href="winZip" download class="btn btn-outline-secondary btn-sm">
          <i class="fas fa-download mr-1"></i> Windows
        </a>
      </div>

      <div v-if="loading" class="text-center py-4 text-muted">
        <i class="fas fa-spinner fa-spin"></i> Generating...
      </div>

      <div v-else-if="pairCode" class="text-center py-4" style="background:var(--wc-primary-light,#e8f5f3);border-radius:12px">
        <p class="text-muted small mb-2">Masukkan kode ini di Connector app</p>
        <div style="font-size:3rem;font-weight:700;letter-spacing:0.25em;color:var(--wc-primary,#128c7e)">
          {{ formattedCode }}
        </div>
        <p class="text-muted small mt-2" :class="{ 'text-danger': expired }">
          {{ expired ? 'Kode kadaluarsa' : `Kadaluarsa dalam ${countdown}` }}
        </p>
        <button class="btn btn-outline-primary btn-sm mt-3" :disabled="loading" @click="generate">
          Generate ulang
        </button>
      </div>

      <div v-if="error" class="alert alert-danger mt-3 mb-0">{{ error }}</div>
    </ContentCard>
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { getConnectorDownloads } from '@/api/connector'

export default {
  data() {
    return {
      pairCode: '',
      expiresAtMs: 0,
      remainingMs: 0,
      loading: false,
      error: '',
      timer: null,
      macZip: `${process.env.BASE_URL}ControlLabs-Connector-macOS.zip`,
      winZip: `${process.env.BASE_URL}ControlLabs-Connector-Windows.zip`,
    }
  },
  computed: {
    formattedCode() {
      const c = this.pairCode
      return c.length === 6 ? `${c.slice(0, 3)} ${c.slice(3)}` : c
    },
    expired() {
      return this.expiresAtMs > 0 && this.remainingMs <= 0
    },
    countdown() {
      const total = Math.max(0, Math.ceil(this.remainingMs / 1000))
      const m = Math.floor(total / 60)
      const s = total % 60
      return `${m}:${String(s).padStart(2, '0')}`
    },
  },
  created() {
    this.loadDownloadUrls()
    this.generate()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    ...mapActions('mission', ['generatePairingCode']),
    async loadDownloadUrls() {
      try {
        const { data } = await getConnectorDownloads()
        const info = data?.data
        if (info?.macosUrl) this.macZip = info.macosUrl
        if (info?.windowsUrl) this.winZip = info.windowsUrl
      } catch (e) {
        // bundled zip fallback in data()
      }
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    tick() {
      this.remainingMs = this.expiresAtMs - Date.now()
      if (this.remainingMs <= 0) this.clearTimer()
    },
    startTimer() {
      this.clearTimer()
      this.tick()
      this.timer = setInterval(this.tick, 1000)
    },
    async generate() {
      this.loading = true
      this.error = ''
      this.clearTimer()
      try {
        const data = await this.generatePairingCode()
        this.pairCode = data.code
        this.expiresAtMs = moment(data.expires_at).valueOf()
        this.startTimer()
      } catch (e) {
        this.error = e.response?.data?.message || 'Gagal generate kode'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
